<template>
  <div>
    <div :class="level==1?'apply-img':level==2?'apply-img2':'apply-img3'"></div>
    <div class="main-container-wrap">
      <div class="main-container">
        <div class="applybox">
          <div
            v-for="(item,index) in applyType"
            :key="item.type"
            :class="applyIndex == index?'apply_button active':'apply_button'"
            @click="changeApplyType(index)"
          >{{item.type}}</div>
        </div>
        <div class="contentArea">
          <div v-show="applyIndex==0">
            <el-table
              :data="info.storageStandardList"
              :span-method="objectSpanMethod2"
              border
              style="width: 100%;"
              header-row-class-name="headerTable"
            >
              <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
              <el-table-column prop="standardLevel" label="级别" width="120" align="center"></el-table-column>
              <el-table-column
                prop="standardClause"
                label="标准条款"
                align="left"
                header-align="center"
              ></el-table-column>
              <el-table-column prop="result" label="是否满足" align="center" width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.result&&scope.row.result=='是'">
                    <i class="el-icon-check" style="color: #409EFF;font-size: 30px;"></i>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 基础信息 -->
          <el-descriptions title="基础信息" :column="2" border v-show="applyIndex==1">
            <el-descriptions-item label="企业名称" labelClassName="labelClassName">{{info.companyName}}</el-descriptions-item>
            <el-descriptions-item label="统一社会信用代码" labelClassName="labelClassName">{{info.uscc}}</el-descriptions-item>
            <el-descriptions-item :span="2"
              label="行业代码"
            >
              <el-table :data="industryList" border>
                 <el-table-column label="一级" prop="industryOne" header-align="center" show-overflow-tooltip></el-table-column>
                 <el-table-column label="二级" prop="industryTwo" header-align="center" show-overflow-tooltip></el-table-column>
                 <el-table-column label="三级" prop="industryThree" header-align="center" show-overflow-tooltip></el-table-column>
                 <el-table-column label="四级" prop="industryFour" header-align="center" show-overflow-tooltip></el-table-column>
              </el-table>
            </el-descriptions-item>
            <!-- <el-descriptions-item
              label="行业代码及名称"
            >{{info.industryParentCode}}{{info.industryCode}}{{info.industryText}}</el-descriptions-item> -->
            <el-descriptions-item
              label="“315”科技创新体系"
            >{{info.scienceTechnologyName}}</el-descriptions-item>
            <el-descriptions-item
              label="“415X”先进制造业集群"
            >{{info.advancedManufactureName}}</el-descriptions-item>
            <el-descriptions-item label="注册资金(万元)">{{info.registeredCapital}}</el-descriptions-item>
            <el-descriptions-item label="所属地区">{{info.areaName}}</el-descriptions-item>
            <el-descriptions-item label="营业执照" :span="2">
              <a
                :href="item.fileUrl"
                v-for="item,i in info.businessLicenseFileList"
                :key="i"
                target="_blank"
              >{{item.fileNames||'营业执照'}}</a>
            </el-descriptions-item>
            <el-descriptions-item label="联系人1">{{info.contactPerson1}}</el-descriptions-item>
            <el-descriptions-item label="联系人1电话">{{info.contactPhone1}}</el-descriptions-item>
            <el-descriptions-item label="联系人2">{{info.contactPerson2}}</el-descriptions-item>
            <el-descriptions-item label="联系人2电话">{{info.contactPhone2}}</el-descriptions-item>
          </el-descriptions>
          <!-- 企业信息 -->
          <div v-show="applyIndex==2">
            <el-descriptions title="企业信息" :column="2" border>
              <el-descriptions-item
                label="企业规模"
                labelClassName="labelClassName"
              >{{info.enterpriseScaleText}}</el-descriptions-item>
              <el-descriptions-item
                label="企业类型"
                labelClassName="labelClassName"
              >{{info.enterpriseTypeText}}</el-descriptions-item>
              <el-descriptions-item label="职工总数(人)">{{info.totalEmployees}}</el-descriptions-item>
              <el-descriptions-item label="科研人员数量(人)">{{info.researchers}}</el-descriptions-item>
              <el-descriptions-item label="科研团队数量(个)">{{info.researchTeams}}</el-descriptions-item>
              <el-descriptions-item label="科研带头人数量(人)">{{info.leadResearchers}}</el-descriptions-item>
              <el-descriptions-item label="知识产权工作全职人员数量(人)">{{info.ipFullTimeStaff}}</el-descriptions-item>
              <el-descriptions-item label="知识产权工作兼职人员数量(人)">{{info.ipPartTimeStaff}}</el-descriptions-item>
              <el-descriptions-item label="是否内设知识产权管理部门">{{info.hasIpDepartmentText}}</el-descriptions-item>
              <el-descriptions-item label="是否加入产业知识产权联盟">{{info.isInIpAlliance}}</el-descriptions-item>
              <el-descriptions-item
                label="联盟名称"
                v-if="info.isInIpAlliance == '是'"
              >{{info.isInIpAllianceText}}</el-descriptions-item>
              <el-descriptions-item
                label="推荐主体"
                :span="2"
              >{{info.recommendedTypeText+'-'+info.recommendedBy}}</el-descriptions-item>
              <el-descriptions-item label="推荐函" :span="2">
                <a
                  style="display:block"
                  :href="item.fileUrl"
                  v-for="item,i in info.recommendationLetterFileList"
                  :key="i"
                  target="_blank"
                >{{item.fileNames||'推荐函'}}</a>
              </el-descriptions-item>
              <el-descriptions-item label="企业称号" :span="2">
                <div v-html="initQych()"></div>
              </el-descriptions-item>
              <el-descriptions-item label="上市情况" :span="2">
                <div v-html="initSsqk()"></div>
              </el-descriptions-item>
            </el-descriptions>
            <!-- 科技创新平台载体建设 -->
            <div>
              <div class="descTitle">科技创新平台载体建设</div>
              <el-table
                :data="info.sciTechPlatforms"
                border
                style="width: 100%"
                header-row-class-name="headerTable"
              >
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="content" label="内容" align="center"></el-table-column>
              </el-table>
            </div>
            <!-- 产学研合作单位 -->
            <div>
              <div class="descTitle">产学研合作单位</div>
              <el-table
                :data="info.academiaIndustryCollaboration"
                border
                style="width: 100%"
                header-row-class-name="headerTable"
              >
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="content" label="内容" align="center"></el-table-column>
              </el-table>
            </div>
            <!-- 当前重点研发项目 -->
            <div>
              <div class="descTitle">当前重点研发项目</div>
              <el-table
                :data="info.researchProjectsList"
                border
                style="width: 100%"
                header-row-class-name="headerTable"
              >
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="projectName" label="项目名称" align="center" width="240"></el-table-column>
                <el-table-column prop="projectDescription" label="项目简介"></el-table-column>
              </el-table>
            </div>
            <!-- 近三年相关专利或技术获各级奖励情况 -->
            <div>
              <div class="descTitle">近三年相关专利或技术获各级奖励情况</div>
              <el-table
                :data="info.patentAwardsList"
                border
                style="width: 100%"
                header-row-class-name="headerTable"
              >
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="awardName" label="奖项" align="center" width="300"></el-table-column>
                <el-table-column prop="patentOrTechName" label="专利号或技术名称" align="center"></el-table-column>
                <el-table-column prop="awardYear" label="获奖年度" align="center" width="100"></el-table-column>
                <el-table-column prop="level" label="等次" align="center" width="100"></el-table-column>
              </el-table>
            </div>
            <!-- 近三年指标数据 -->
            <div>
              <div class="descTitle">近三年指标数据</div>
              <el-table
                :data="economicIndicatorsList"
                border
                style="width: 100%"
                header-row-class-name="headerTable"
              >
                <el-table-column
                  class-name="cellTable"
                  prop="name"
                  label="近三年指标数据"
                  align="center"
                  width="200"
                ></el-table-column>
                <el-table-column
                  :prop="'type'+(i+1)"
                  :label="item+'年'"
                  align="center"
                  v-for="item,i in economicIndicatorsYear"
                  :key="i"
                ></el-table-column>
              </el-table>
            </div>
            <!-- 知识产权管理体系建设情况 -->
            <div style="margin: 40px 0;">
              <el-descriptions title="知识产权管理体系建设情况" :column="2" border>
                <el-descriptions-item label="知识产权管理体系建设情况" labelClassName="labelClassName2">
                  <div v-html="initJsqk()"></div>
                </el-descriptions-item>
              </el-descriptions>
            </div>
            <!-- 专业技术人员 -->
            <el-descriptions title="专业技术人员" :column="2" border v-if="info.professionals">
              <el-descriptions-item
                v-if="info.professionals.indexOf('知识产权经济师') > -1"
                label="知识产权经济师"
                labelClassName="labelClassName"
              >{{info.professionalsEconomist}}人</el-descriptions-item>
              <el-descriptions-item
                v-if="info.professionals.indexOf('专利代理师') > -1"
                label="专利代理师"
                labelClassName="labelClassName"
              >{{info.professionalsAgent}}人</el-descriptions-item>
              <el-descriptions-item
                label="国际创新管理师"
                v-if="info.professionals.indexOf('国际创新管理师') > -1"
              >{{info.professionalsManager}}人</el-descriptions-item>
              <el-descriptions-item
                label="其他专业技术人员"
                v-if="info.professionals.indexOf('其他专业技术人员') > -1"
              >{{info.professionalsOthers}}</el-descriptions-item>
            </el-descriptions>
          </div>
          <!-- 知识产权 -->
          <div v-show="applyIndex==3">
            <el-descriptions title="海外申请知识产权数量(件)" :column="2" border>
              <el-descriptions-item
                label="发明"
                labelClassName="labelClassName"
              >{{info.overseasAppliedInventions}}</el-descriptions-item>
              <el-descriptions-item
                label="商标"
                labelClassName="labelClassName"
              >{{info.overseasAppliedTrademark}}</el-descriptions-item>
              <el-descriptions-item
                label="其他"
                labelClassName="labelClassName"
              >{{info.overseasAppliedOther}}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="海外有效知识产权数量(件)" :column="2" border>
              <el-descriptions-item
                label="发明"
                labelClassName="labelClassName"
              >{{info.overseasEffectiveInventions}}</el-descriptions-item>
              <el-descriptions-item
                label="商标"
                labelClassName="labelClassName"
              >{{info.overseasEffectiveTrademark}}</el-descriptions-item>
              <el-descriptions-item
                label="其他"
                labelClassName="labelClassName"
              >{{info.overseasEffectiveOther}}</el-descriptions-item>
            </el-descriptions>
            <!-- 国内有效知识产权数量(件) -->
            <el-descriptions title="国内有效知识产权数量(件)" :column="2" border style="margin-top: 40px;">
              <el-descriptions-item
                label="发明"
                labelClassName="labelClassName"
              >{{info.effectiveInventions}}</el-descriptions-item>
              <el-descriptions-item
                label="实用新型"
                labelClassName="labelClassName"
              >{{info.effectiveUtilities}}</el-descriptions-item>
              <el-descriptions-item
                label="外观设计"
                labelClassName="labelClassName"
              >{{info.effectiveDesigns}}</el-descriptions-item>
              <el-descriptions-item
                label="商标"
                labelClassName="labelClassName"
              >{{info.effectiveTrademark}}</el-descriptions-item>
            </el-descriptions>
          </div>
          <!-- 专利转化情况 -->
          <div v-show="applyIndex==4">
            <!-- 自主商标品牌建设情况 -->
            <div>
              <div class="descTitle">自主商标品牌建设情况</div>
              <el-table
                :data="info.brandConstructionList"
                border
                style="width: 100%"
                header-row-class-name="headerTable"
              >
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="brandName" label="品牌名称" align="center"></el-table-column>
                <el-table-column prop="trademarkNumber" label="主商标号" align="center"></el-table-column>
                <el-table-column prop="revenue" label="产值(万元)" align="center" width="120"></el-table-column>
              </el-table>
            </div>
            <!-- 参加专利池运营情况 -->
            <div>
              <div class="descTitle">参加专利池运营情况</div>
              <el-table
                :data="info.patentPoolOperationsList"
                border
                style="width: 100%"
                header-row-class-name="headerTable"
              >
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="operator" label="专利池运营方" align="center"></el-table-column>
                <el-table-column prop="poolName" label="专利池名称" align="center"></el-table-column>
              </el-table>
              <el-descriptions :column="2" border style="margin-top: 40px;">
                <el-descriptions-item
                  label="运营专利数量总数(个)"
                  labelClassName="labelClassName"
                >{{info.totalPatents}}</el-descriptions-item>
                <el-descriptions-item
                  label="备案的专利密集型产品数量(个)"
                  labelClassName="labelClassName"
                >{{info.registeredPatentProducts}}</el-descriptions-item>
                <el-descriptions-item
                  label="备案的专利密集型产品销售收入(万元)"
                  labelClassName="labelClassName"
                >{{info.patentProductSales}}</el-descriptions-item>
                <el-descriptions-item
                  label="认定的专利密集型产品数量(个)"
                  labelClassName="labelClassName"
                >{{info.densePatentProducts}}</el-descriptions-item>
                <el-descriptions-item
                  label="认定的专利密集型产品销售收入(万元)"
                  labelClassName="labelClassName"
                >{{info.densePatentSales}}</el-descriptions-item>
              </el-descriptions>
            </div>
            <!-- 近三年指标数据 -->
            <div>
              <div class="descTitle">近三年指标数据</div>
              <el-table
                :data="patentConversionMetricsList"
                border
                style="width: 100%"
                header-row-class-name="headerTable"
              >
                <el-table-column
                  class-name="cellTable"
                  prop="name"
                  label="近三年指标数据"
                  align="center"
                  width="200"
                ></el-table-column>
                <el-table-column
                  :prop="'type'+(i+1)"
                  :label="item+'年'"
                  align="center"
                  v-for="item,i in patentConversionMetricsYear"
                  :key="i"
                ></el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 企业需求收集 -->
          <div v-show="applyIndex==5">
            <el-table
              :data="info.companyDemandItemList"
              :span-method="objectSpanMethod"
              border
              style="width: 100%;"
              header-row-class-name="headerTable"
            >
              <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
              <el-table-column prop="itemCategory" label="分类" width="120" align="center"></el-table-column>
              <el-table-column prop="item" label="企业需求项" align="center"></el-table-column>
              <el-table-column prop="result" label="需求情况" align="center" width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.result&&scope.row.result=='是'">
                    <i class="el-icon-check" style="color: #409EFF;font-size: 30px;"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="selects" label="更多" align="center" width="300">
        <template slot-scope="scope">
          <div v-if="scope.row.item == '专利快速预审' && scope.row.result == '是'">
            <template v-if="scope.row.centerFirst">
              <div style="text-align:left">浙江省知识产权保护中心</div>
              <div class="select-view">
                <div class="sv-t">IPC分类</div>
                <div class="sv-btn">
                  <el-button size="small" @click="openViewDialog('ipc1')">查看</el-button>
                </div>
              </div>
              <reqdialogView :view_dialogVisible.sync="view_dialogVisible" :tableData.sync="scope.row.centerFirstIpc" :areaCode="'330000'" v-if="view_dialogVisible && pType=='ipc1'"></reqdialogView>
            </template>
            <template v-if="scope.row.centerSecond">
              <div style="text-align:left">{{cityText+'知识产权保护中心'}}</div>
              <div class="select-view">
                <div class="sv-t">IPC分类</div>
                <div class="sv-btn">
                  <el-button size="small" @click="openViewDialog('ipc2')">查看</el-button>
                </div>
              </div>
            <reqdialogView :view_dialogVisible.sync="view_dialogVisible" :tableData.sync="scope.row.centerSecondIpc" :areaCode="areaCode" v-if="view_dialogVisible && pType=='ipc2'"></reqdialogView>
          </template>
          </div>
        </template>
      </el-table-column>
            </el-table>
          </div>
          <div class="timeFlow mb20 mt20">
            <div class="tb-title">历史流程记录</div>
            <div class="flowList">
              <el-timeline :reverse="false" class="timelineNode">
                <el-timeline-item
                  v-for="(item, index) in info.adviceList"
                  :key="item.createTime"
                  :timestamp="item.createTime"
                  placement="top"
                  :icon="(index + 1) == info.adviceList.length ? 'el-icon-circle-check' : 'el-icon-remove'"
                  :color="(index + 1) == info.adviceList.length ? '#ff9630' : ''"
                  size="large"
                >
                  <span
                    :class="item.auditStatus==0?'red adname':'adname'"
                    :title="item.createUserNickname"
                  >【{{item.createUserNickname}}】</span>
                  <span :class="item.auditStatus==0?'red':''">【{{item.operate}}】</span>
                  {{&nbsp;&nbsp;&nbsp;}}
                  <span
                    :class="item.auditStatus==0?'red advice':'advice'"
                  >{{ item.advice }}</span>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
          <!-- <div class="mb20">
            <div class="tb-title mb20">评价记录</div>
            <el-descriptions
              :column="2"
              labelClassName="label_class"
              contentClassName="content_class"
              border
            >
              <el-descriptions-item :span="2" label="评价">kooriookami</el-descriptions-item>
              <el-descriptions-item :span="2" label="原因">199832313</el-descriptions-item>
            </el-descriptions>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { applyView } from "@/api/index";
import reqdialogView from "./applypage/components/reqdialogView.vue"
export default {
  name: "applyView",
  components: {
    reqdialogView
  },
  data() {
    return {
      applyType: [
        { type: "入库标准" },
        { type: "基础信息" },
        { type: "企业信息" },
        { type: "知识产权" },
        { type: "专利转化情况" },
        { type: "企业需求收集" }
      ],
      applyIndex: 0,
      info: {
        companyName: "111",
        sciTechPlatforms: [{ content: 111 }],
        academiaIndustryCollaboration: [{ content: 111 }],
        researchProjectsList: [{ name: "111", content: "222" }],
        patentAwardsList: [
          {
            type1: "科学技术奖",
            type2: "xxx发明专利",
            type3: "2024",
            type4: "优"
          }
        ],
        list6: [{ type1: "111", type2: "222", type3: "333" }],
        list7: [{ type1: "111", type2: "222" }]
      },
      economicIndicatorsList: [
        {
          name: "年营业收入（万元）",
          type1: "001",
          type2: "111",
          type3: "222"
        },
        { name: "年利润（万元）", type1: "001", type2: "111", type3: "222" },
        { name: "科研投入（万元）", type1: "001", type2: "111", type3: "222" },
        {
          name: "知识产权投入（万元）",
          type1: "001",
          type2: "111",
          type3: "222"
        }
      ],
      economicIndicatorsYear: [],
      patentConversionMetricsList: [
        { name: "专利许可数量(件)", type1: "001", type2: "111", type3: "222" },
        {
          name: "专利许可总金额(万元)",
          type1: "001",
          type2: "111",
          type3: "222"
        },
        { name: "专利转让数量(件)", type1: "001", type2: "111", type3: "222" },
        {
          name: "专利转让总金额(万元)",
          type1: "001",
          type2: "111",
          type3: "222"
        },
        {
          name: "被许可专利数量(件)",
          type1: "001",
          type2: "111",
          type3: "222"
        },
        {
          name: "受让专利数量(含购买、作价入股)(件)",
          type1: "001",
          type2: "111",
          type3: "222"
        },
        {
          name:
            "专利产业化情况(用于生产出产品并投放于市场的专利件数,包括自实施和许可他人实施的)(件)",
          type1: "001",
          type2: "111",
          type3: "222"
        },
        {
          name: "证券化专利数量(件)",
          type1: "001",
          type2: "111",
          type3: "222"
        },
        { name: "证券化金额(万元)", type1: "001", type2: "111", type3: "222" },
        {
          name:
            "其他方式贷款金额(知识产权质押融资外其他方式贷款、外部投资等)(万元)",
          type1: "001",
          type2: "111",
          type3: "222"
        },
        {
          name: "外部投资金额(万元)",
          type1: "001",
          type2: "111",
          type3: "222"
        },
        {
          name: "专利质押融资贷款金额(万元)",
          type1: "001",
          type2: "111",
          type3: "222"
        },
        {
          name: "商标质押融资贷款金额(万元)",
          type1: "001",
          type2: "111",
          type3: "222"
        }
      ],
      level: "",
      patentConversionMetricsYear: [],
      view_dialogVisible:false,
      provinceOptions:[
        {label:"浙江省知识产权保护中心",value:"330000"}
      ],
      cityOptions:[
          {label:"杭州市知识产权保护中心",value:"330100"},
          {label:"宁波市知识产权保护中心",value:"330200"},
          {label:"温州市知识产权保护中心",value:"330300"},
          {label:"嘉兴市知识产权保护中心",value:"330400"},
          {label:"台州市知识产权保护中心",value:"331000"},
      ],
      pType:"",
      areaCode:"",
      industryList:[]
    };
  },
  created() {
    this.getInfo();
  },
  computed:{
    cityText(){
        return {
          '3301':'杭州市',
          '3302':'宁波市',
          '3303':'温州市',
          '3304':'嘉兴市',
          '3310':'台州市',
        }[this.info.areaCode?.slice(0,4)]
    },
  },
  methods: {
    // 获取数据
    getInfo() {
      applyView(this.$route.query.id).then(res => {
        this.info = res.data || {};
        this.level = this.info.type;
        this.initCompanyZb();
        this.initZlzh();
        this.info.companyDemandItemList.push({
          itemCategory: "其他",
          item:
            this.info.companyDemandItem == 1
              ? this.info.companyDemandItemOther
              : "",
          result: this.info.companyDemandItem == 1 ? "是" : ""
        });
        
        this.cityOptions = this.cityOptions.filter(e=>this.info.areaCode?.slice(0,4) == e.value.slice(0,4) )
        this.areaCode = this.info.areaCode?.slice(0,4) + '00'
        if(!this.info.industryFourCode){//2级数据
          if(this.info.industryCode){
            this.industryList = [{
              industryOne:this.info.industryParentText+'('+this.info.industryParentCode+')',
              industryTwo:this.info.industryText+'('+this.info.industryCode+')',
              industryThree:"",
              industryFour:"",
            }]
          }else{
            this.industryList = []
          }
        }else {//4级数据
          this.industryList = []
          let codeList = this.info.industryFourCode.split(',')
          let nameList = this.info.industryFourName.split(',')
          console.log(codeList,nameList)
          for(let i=0;i<codeList.length;i++){
              this.industryList.push({
                industryOne:this.info.industryParentText+'('+this.info.industryParentCode+')',
                industryTwo:this.info.industryText+'('+this.info.industryCode+')',
                industryThree:nameList[i].split('/')[0]+'('+codeList[i].split('/')[0]+')',
                industryFour:nameList[i].split('/')[1]+'('+codeList[i].split('/')[1]+')',
              })
          }
        }
      });
    },
    // 处理企业信息近三年指标数据
    initCompanyZb() {
      this.economicIndicatorsYear = [];
      this.info.economicIndicatorsList?.forEach((e, i) => {
        this.economicIndicatorsYear.push(e.annualYear);
        this.economicIndicatorsList[0]["type" + (i + 1)] = e.annualRevenue;
        this.economicIndicatorsList[1]["type" + (i + 1)] = e.annualProfit;
        this.economicIndicatorsList[2]["type" + (i + 1)] = e.researchInvestment;
        this.economicIndicatorsList[3]["type" + (i + 1)] = e.iprInvestment;
      });
    },
    // 处理专利转化情况近三年指标数据
    initZlzh() {
      this.patentConversionMetricsYear = [];
      this.info.patentConversionMetricsList?.forEach((e, i) => {
        this.patentConversionMetricsYear.push(e.metricsYear);
        this.patentConversionMetricsList[0]["type" + (i + 1)] = e.licenseCount;
        this.patentConversionMetricsList[1]["type" + (i + 1)] =
          e.licenseTotalAmount;
        this.patentConversionMetricsList[2]["type" + (i + 1)] = e.transferCount;
        this.patentConversionMetricsList[3]["type" + (i + 1)] =
          e.transferTotalAmount;
        this.patentConversionMetricsList[4]["type" + (i + 1)] =
          e.licensedPatentsCount;
        this.patentConversionMetricsList[5]["type" + (i + 1)] =
          e.acquiredPatentsCount;
        this.patentConversionMetricsList[6]["type" + (i + 1)] =
          e.industrializedPatentsCount;
        this.patentConversionMetricsList[7]["type" + (i + 1)] =
          e.securitizedPatentsCount;
        this.patentConversionMetricsList[8]["type" + (i + 1)] =
          e.securitizationAmount;
        this.patentConversionMetricsList[9]["type" + (i + 1)] =
          e.otherLoanAmount;
        this.patentConversionMetricsList[10]["type" + (i + 1)] =
          e.externalInvestmentAmount;
        this.patentConversionMetricsList[11]["type" + (i + 1)] =
          e.patentPledgeLoanAmount;
        this.patentConversionMetricsList[12]["type" + (i + 1)] =
          e.trademarkPledgeLoanAmount;
      });
    },
    // 企业称号其他项替换
    initQych() {
      let str = "";
      let domstr = "";
      if (this.info.enterpriseTitle) {
        if (
          this.info.enterpriseTitle?.indexOf("其他") > -1 &&
          this.info.enterpriseTitleOthers
        ) {
          str = this.info.enterpriseTitle.replace(
            "其他",
            "其他(" + this.info.enterpriseTitleOthers + ")"
          );
        } else {
          str = this.info.enterpriseTitle;
        }
        str.split(";").forEach(e => {
          domstr += `<div>${e}</div>`;
        });
      }
      return domstr || str;
    },
    // 上市情况替换
    initSsqk() {
      let str = "";
      let domstr = "";
      if (this.info.listingStatus) {
        if (
          this.info.listingStatus?.indexOf("近期有上市计划") > -1 &&
          this.info.listingStatusYear
        ) {
          str = this.info.listingStatus.replace(
            "近期有上市计划",
            "近期有上市计划，预计在" +
              this.info.listingStatusYear +
              "提交上市申请"
          );
        } else {
          str = this.info.listingStatus;
        }
        str.split(";").forEach(e => {
          domstr += `<div>${e}</div>`;
        });
      }
      return domstr || str;
    },
    // 建设情况其他替换
    initJsqk() {
      let str = "";
      let domstr = "";
      if (this.info.ipManagementSystem) {
        str = this.info.ipManagementSystem;
        // console.log(this.info.ipManagementSystem,this.info.ipManagementSystem?.indexOf("其他") > -1,this.info.ipManagementSystemOther)
        if (
          this.info.ipManagementSystem?.indexOf("其他") > -1 &&
          this.info.ipManagementSystemOther
        ) {
          str = str.replace(
            "其他",
            "其他(" + this.info.ipManagementSystemOther + ")"
          );
        }
        if (
          this.info.ipManagementSystem?.indexOf(
            "通过创新管理知识产权管理体系评价"
          ) > -1 &&
          this.info.ipManagementSystemLevel
        ) {
          str = str.replace(
            "通过创新管理知识产权管理体系评价",
            "通过创新管理知识产权管理体系评价(" +
              this.info.ipManagementSystemLevel +
              ")"
          );
        }
        str.split(";").forEach(e => {
          domstr += `<div>${e}</div>`;
        });
      }
      return domstr || str;
    },
    // 切换
    changeApplyType(index) {
      if (this.applyIndex != index) {
        this.applyIndex = index;
      }
    },
    // 合并单元格
    // 获取需要合并的行
    getRow(data, item) {
      let pos = "";
      let spanArr = [];
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          spanArr.push(1);
          pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i][item] === data[i - 1][item]) {
            spanArr[pos] += 1;
            spanArr.push(0);
          } else {
            spanArr.push(1);
            pos = i;
          }
        }
      }
      return spanArr;
    },

    /// 合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        const _row = this.getRow(
          this.info.companyDemandItemList,
          "itemCategory"
        )[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    objectSpanMethod2({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        const _row = this.getRow(
          this.info.storageStandardList,
          "standardLevel"
        )[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    openViewDialog(name){
       this.pType= name
       this.view_dialogVisible = true
    },
  }
};
</script>
<style scoped lang="less">
.app-background {
  background-color: #f4f6fa;
  min-width: 1200px;
}

#banner-wrap {
  width: 100%;
  // max-width: 1200px;
  height: 520px;
  // background-color: blue;

  background-size: 100% 100%;
}
.apply-img {
  width: 100%;
  height: 180px;
  background-image: url("../assets/fuhua.png");
  background-size: 100% 100%;
}
.apply-img2 {
  width: 100%;
  height: 180px;
  background-image: url("../assets/chengzhang.png");
  background-size: 100% 100%;
}
.apply-img3 {
  width: 100%;
  height: 180px;
  background-image: url("../assets/yangban.png");
  background-size: 100% 100%;
}
.applybox {
  display: flex;
  padding: 30px 0;
  justify-content: space-between;
  background-color: #f5f6fa;
  .apply_button {
    border-radius: 24.78px;
    font-size: 18px;
    cursor: pointer;
    padding: 12px 50px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #3f93f6;
  }
  .apply_button.active {
    color: #fff;
    background-color: #3f93f6;
  }
}
.contentArea {
  min-height: calc(100vh - 500px);
  background-color: #fff;
  margin-bottom: 20px;
  padding: 30px;
  border-radius: 4px;
}
.descTitle {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
  padding: 40px 0 20px;
}
/deep/ .label_class {
  width: 15%;
  text-align: right !important;
  font-weight: 700 !important;
  color: #6c6c6c;
}
/deep/ .content_class {
  width: 85%;
  color: #6c6c6c;
}
.selectmore {
    display: flex;
    justify-content: space-between;
    .t{
      width: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .s {
      flex: 1;
      .el-input {
        width: 100%;
      }
    }
}
.select-view {
  display:flex;
  margin: 10px 0;
  justify-content: space-between;
  .sv-t{
    width: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .sv-btn {
    flex: 1;
  }
}
</style>
<style>
.labelClassName {
  width: 140px;
}
.labelClassName2 {
  width: 200px;
}
.headerTable th.el-table__cell {
  background-color: #fafafa;
}
.cellTable {
  background-color: #fafafa;
  color: #909399;
  font-weight: 600;
}
.timeFlow {
  background-color: #fff;
  width: 100%;
  height: 300px;
  box-sizing: border-box;
  border-top: 1px solid #fff;

  .flowList {
    margin: 0 auto;
    margin-top: 35px;
    width: 1050px;
    height: 230px;
    overflow-y: auto;
  }
}

/deep/ .el-timeline-item__timestamp {
  text-align: left;
  font-size: 14px;
}

/deep/ .el-timeline-item__content {
  margin-top: -26px;
  text-align: left;
  text-indent: 210px;
}

.timelineNode {
  margin: 10px;
}
.red {
  color: #f00;
}
.advice {
  width: 500px;
  vertical-align: bottom;
}
.adname {
  max-width: 300px;
  vertical-align: bottom;
}

</style>